var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-page-header",attrs:{"data-testid":"email-notifications__header"}},[_c('h3',{staticClass:"notifications-page-header__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"notifications-page-header__desc"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }